import { FORM_TYPES, LEGALES_LEALTAD_AFS, TITLE } from "../../data/AudiNuevo/preventa";

const TitleComponent = ({ formType, modelPathName, utms }) => {
  let titleText = '';
  if (formType !== FORM_TYPES.PREVENTA.LEALTAD && formType !== FORM_TYPES.PREVENTA.CONQUISTA) {
    return <p className="mb-3">
      Por favor completa el siguiente formulario. Nos pondremos en contacto contigo para resolver tus dudas y brindarte la información que necesitas sobre tu Audi.
    </p>
  }

  if (formType === FORM_TYPES.PREVENTA.LEALTAD) {
    titleText = TITLE[modelPathName]?.LEALTAD || "Preventa Lealtad";
  } else if (formType === FORM_TYPES.PREVENTA.CONQUISTA) {
    titleText = TITLE[modelPathName]?.CONQUISTA || "Preventa Conquista";
  }

  if (utms.utm_id && utms.utm_id === "PreventaAFS") {
    titleText = LEGALES_LEALTAD_AFS[modelPathName].TITLE || "";
  }
  return (
    <p className="text-center mb-5"
      style={{ fontSize: "2.5rem", fontWeight: "200", fontFamily: "AudiTypeExt", lineHeight: "3.25rem", paddingTop: "93px", paddingBottom: "200px", whiteSpace: "pre-line" }}
    >{
        titleText
      }</p>
  )
}

export default TitleComponent;
